import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

export const useWrapper = makeStyles()(({ breakpoints, spacing }: Theme) => ({
  menu: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
    padding: spacing(0, 1, 2, 1),
  },
  button: {
    width: '100%',
    margin: spacing(2, 1.5),
    '& .MuiButton-startIcon': {
      display: 'none',
    },
    [breakpoints.between('sm', 'lg')]: {
      minWidth: spacing(4),
      paddingLeft: spacing(1),
      paddingRight: spacing(1),
      margin: 0,
      '& .MuiButton-startIcon': {
        margin: 0,
        display: 'flex',
      },
    },
    [breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  buttonText: {
    [breakpoints.between('sm', 'lg')]: {
      display: 'none',
    },
  },
}));
